import * as $ from 'jquery';
import * as React from 'react';

import { IGlob } from '../../../_common/application/ts/Glob';
import BooleanField from '../../../_common/platform/tsx/BooleanField';

import ClickToFilterAttributeSelect, {
    IToggleStates
} from '../../../_common/platform/tsx/filtering/ClickToFilterAttributeSelect';

export { IToggleStates } from '../../../_common/platform/tsx/filtering/ClickToFilterAttributeSelect';

import * as Utils from '../../../_common/platform/ts/Utilities';
import { IAttribute, IAttributeName } from '../../../_common/platform/tsx/filtering/Interfaces';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';

import { CLICK_TO_FILTER_NOT_USED_VALUE } from '../../../_common/platform/tsx/filtering/Constants';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick'); //LL: 04.09.19

require('../../../_common/platform/sass/attribute-options-select.sass');

export interface IValue {
    clickToFilterAttribute?: IAttribute;
    showInTooltip?: boolean;
}

export interface IAttributeOptionsSelectProps {
    value: IValue;
    attribute?: IAttributeName;
    dataSourceID: number;
    tabID: number;

    options?: any; //LL: 13.08.19  { show_clickToFilter: true, show_showInTooltip: true }

    entitiesTree: any[];
    entityCollapsedDict: IToggleStates;
    disableClickToFilter: boolean;

    glob: IGlob;

    onChange?(value: IValue): void;
    onEntityCollapsedDictChange?(value): void;
}

interface IOptionsSelectPopupOptions extends IPopupOptions {
    value: IValue;
    attribute: IAttributeName;
    dataSourceID: number;

    options?: any; //LL: 13.08.19  { show_clickToFilter: true, show_showInTooltip: true }

    entitiesTree: any[];
    entityCollapsedDict: IToggleStates;
    disableClickToFilter: boolean;
    tabID: number;

    onChange(value: IValue): void;
    onEntityCollapsedDictChange?(value): void;
}

class OptionsSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IOptionsSelectPopupOptions;

        glob: IGlob;

        close(): void;
    },
    {
        value: IValue;
        height: number;
        width: number;
    }
> {
    private references: {
        popover_body?: HTMLDivElement | null;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            value: this.getValueCopy(this.props.options.value),
            height: 390,
            width: 700
        };
    }

    getValueCopy(value: IValue): IValue {
        return (value != null ? $.extend(true, {}, value) : {}) as IValue;
    }

    handleValueChange = () => {
        this.setState(this.state);
    };

    handleOKButtonClick = () => {
        this.props.close();

        if (typeof this.props.options.onChange === 'function') {
            const valueCopy = this.getValueCopy(this.state.value);
            this.props.options.onChange(valueCopy);
        }
    };

    handleClickToFilterAttributeChange = (value: IAttribute) => {
        if (value != null) {
            this.state.value.clickToFilterAttribute = value;
        } else {
            delete this.state.value.clickToFilterAttribute;
        }
        this.handleValueChange();
    };

    handleShowInTooltipChange = (value: boolean) => {
        this.state.value.showInTooltip = value;
        this.handleValueChange();
    };

    private globalClickIndex = 0; //LL: 04.09.19: problem when click "Save" on Config dialog instead of this dialog

    componentDidMount() {
        this.globalClickIndex = reactGlobalClick.register(this.props.close); //LL: 04.09.19

        const dialog = this.references.popover_body;

        this.setState({ ...this.state, height: dialog.clientHeight, width: dialog.clientWidth });
    }

    //LL: 04.09.19
    componentWillUnmount() {
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    render() {
        const options = this.props.options;
        const value = this.state.value;

        const popoverStyle = Utils.getPopoverStyle(options, {
            width: this.state.width,
            height: this.state.height
        });

        const zIndex = options.zIndex != null ? options.zIndex : this.props.zIndex;

        const style = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: zIndex
        };

        let clickToFilter_elem;

        if (options.options != null && options.options.show_clickToFilter !== false) {
            clickToFilter_elem = (
                <ClickToFilterAttributeSelect
                    value={value.clickToFilterAttribute}
                    attributeName={options.attribute}
                    dataSourceID={options.dataSourceID}
                    entitiesTree={options.entitiesTree}
                    entityCollapsedDict={options.entityCollapsedDict}
                    disableByOption={options.disableClickToFilter}
                    tabID={options.tabID}
                    glob={this.props.glob}
                    onChange={this.handleClickToFilterAttributeChange}
                    onEntityCollapsedDictChange={options.onEntityCollapsedDictChange}
                />
            );
        }

        let showInTooltip_elem;
        if (options.options != null && options.options.show_showInTooltip === true) {
            // default false
            let displayVal =
                options.options.showInTooltip_displayVal != null ? options.options.showInTooltip_displayVal : false;
            let disabled =
                options.options.showInTooltip_disabled != null ? options.options.showInTooltip_disabled : false;

            //const divTooltipStyle = {
            //    backgroundColor: 'lightgray'
            //};
            //let ShowInTooltipStyle = disabled ? divTooltipStyle : null;
            let ShowInTooltipStyle: any = {
                display: 'inline-block',
                marginLeft: '0.5em',
                textAlign: 'center',
                padding: '5px',
                width: '40px'
            };

            if (disabled) {
                ShowInTooltipStyle.backgroundColor = 'lightgray';
            }

            showInTooltip_elem = (
                <div style={{ marginTop: '1em' }}>
                    <strong>{'Show in Tooltip:'}</strong>
                    <div style={ShowInTooltipStyle}>
                        <BooleanField
                            title={''}
                            value={displayVal}
                            disabled={disabled}
                            allowNull={false}
                            onChange={this.handleShowInTooltipChange}
                        />
                    </div>
                </div>
            );
        }

        //  { 'x' }
        return (
            <div className="attribute-options-select-dialog">
                <div
                    className={'popover attribute-options-select-popover ' + popoverStyle.side}
                    style={style}
                    ref={(input: HTMLDivElement | null) => {
                        this.references.popover_body = input;
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {'More Options'}
                        <button type="button" className="close" onClick={this.props.close}>
                            ×
                        </button>
                    </h3>
                    <div className="popover-body">
                        {clickToFilter_elem}
                        {showInTooltip_elem}
                    </div>
                    <div className="modal-footer">
                        <div className="btn btn-success button-confirm" onClick={this.handleOKButtonClick}>
                            {'OK'}
                        </div>
                        <button className="btn btn-default" onClick={this.props.close}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

export default class AttributeOptionsSelect extends React.Component<IAttributeOptionsSelectProps, {}> {
    constructor(props) {
        super(props);
    }

    handleChange = (value: IValue) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    handleSelectorShow = (e) => {
        const offset = $(e.target).offset();

        this.props.glob.DialogActions.createPopup<IOptionsSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value,
            attribute: this.props.attribute,
            dataSourceID: this.props.dataSourceID,
            disableClickToFilter: false, //EU 24.10.2019. This paramenter was not defined here, but Lena has specified it in the popup options.
            tabID: this.props.tabID,

            options: this.props.options, //LL: 13.08.19

            entitiesTree: this.props.entitiesTree,
            entityCollapsedDict: this.props.entityCollapsedDict,

            onChange: this.handleChange,
            onEntityCollapsedDictChange: this.props.onEntityCollapsedDictChange,

            component: OptionsSelectPopup
        });
    };

    //LL
    getTooltip = () => {
        const { value } = this.props;
        const attribute =
            value != null && value.clickToFilterAttribute != null ? value.clickToFilterAttribute.attribute : null;

        let c2f_text = '';
        if (attribute === CLICK_TO_FILTER_NOT_USED_VALUE) {
            //return "ClickToFilter is disabled";
            c2f_text = 'ClickToFilter is disabled';
        } else {
            //return "clickToFilterAttribute = " + attribute;
            c2f_text = 'clickToFilterAttribute = ' + attribute;
        }

        //LL: 13.01.20:
        let showInTooltip_text = '';
        let show_showInTooltip =
            this.props.options != null && this.props.options.show_showInTooltip != null
                ? this.props.options.show_showInTooltip
                : false;
        if (show_showInTooltip) {
            const defaultVal =
                this.props.options != null && this.props.options.showInTooltip_displayVal != null
                    ? this.props.options.showInTooltip_displayVal
                    : false;
            const showInTooltip = value != null && value.showInTooltip != null ? value.showInTooltip : defaultVal;
            if (showInTooltip != null) {
                showInTooltip_text = 'showInTooltip = ' + showInTooltip;
            }
        }

        return c2f_text + '; ' + showInTooltip_text;
    };

    //LL: 13.01.20:
    hasValueSet = () => {
        const { value } = this.props;
        const attribute =
            value != null && value.clickToFilterAttribute != null ? value.clickToFilterAttribute.attribute : null;
        let c2f_set = attribute != null && attribute !== CLICK_TO_FILTER_NOT_USED_VALUE;
        if (c2f_set) {
            return true;
        }

        let showInTooltip_set = false;
        let show_showInTooltip =
            this.props.options != null && this.props.options.show_showInTooltip != null
                ? this.props.options.show_showInTooltip
                : false;
        if (show_showInTooltip) {
            const showInTooltip = value != null ? value.showInTooltip : null;
            if (showInTooltip != null) {
                showInTooltip_set = true;
            }
        }
        return showInTooltip_set;
    };

    render() {
        var title = this.getTooltip(); //LL

        //LL: 13.01.20:  use "equalizer" glyph
        let hasValueSetElem;
        if (this.hasValueSet()) {
            hasValueSetElem = (
                <span
                    className="glyphicon glyphicon-equalizer"
                    title={title}
                    style={{ cursor: 'pointer' }}
                    onClick={this.handleSelectorShow}
                ></span>
            );
        }

        return (
            <div className="attribute-options-select">
                <div className="content" title={title}>
                    <span className="glyphicon glyphicon-cog" onClick={this.handleSelectorShow}></span>

                    {hasValueSetElem}

                    <span className="value" title={''}>
                        <em className="empty" onClick={this.handleSelectorShow}></em>
                    </span>
                </div>
            </div>
        );
    }
}
